import * as Sentry from "@sentry/react";
import pkg from "../package.json";
import { getEnvironmentByHostname, shouldEnableSentry } from "@/constants";

// Get current hostname and environment
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const environment = getEnvironmentByHostname(hostname);
const enableSentry = shouldEnableSentry(hostname);

// Decide whether to enable Sentry based on environment
if (enableSentry && import.meta.env.PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.PUBLIC_SENTRY_DSN,
    tracesSampleRate: environment === "production" ? 0.1 : 0,
    replaysSessionSampleRate: environment === "production" ? 0.1 : 0,
    replaysOnErrorSampleRate: environment === "production" ? 1.0 : 0,
    release: pkg.version,
    environment: environment,
    sendDefaultPii: environment === "production",
    ignoreErrors: [
      /fbq is not defined/,
      /Can't find variable: fbq/,
      /A tree hydrated but some/,
      /Can't perform a React state update/,
      /must be invoked within/,
      // QA environment: additionally ignore some testing-related errors
      ...(environment === "qa"
        ? [
            /ResizeObserver loop limit exceeded/,
            /Non-Error promise rejection captured/,
            /Loading chunk \d+ failed/,
            /Script error/,
            /Network Error/
          ]
        : [])
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
      // Only enable replay in production environment
      ...(environment === "production"
        ? [
            // Sentry.replayIntegration()
          ]
        : [])
    ]
  });

  console.log(
    `Sentry initialized for ${environment} environment (${hostname})`
  );
} else {
  console.log(`Sentry disabled for ${environment} environment (${hostname})`);
}
